import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import Wnd_Ok from "../../../lib/ui/wnd_ok";
import Bq_Bong from "./bq_bong";

class Bq_List extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.state = {};
    this.state.bqa = [];
    this.state.tra = [];
    this.state.msg = {};
    this.state.wnds = {};
   }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.bqn();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    bq_close() {
        this.props.ctx.setState({ wnds: {} });
    };
    tb_style() {
      var css = {};
      //css.height = window.innerHeight - 275;
        css.overflow = "auto";
      return css;
    }

    bqn() {
        var self = this;
        var prm = {};
        prm.req = "pos.pos_bq.bqn";
        prm.avd = this.state.avd;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret));

            self.setState({bqa: ret.rca });
            self.syncTb("bqnTable");
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    show_bong(row) {
    //alert(JSON.stringify(row));
      var self = this;
      var wnds = {};
      wnds.bong = true;
      wnds.row = row;
      wnds.backdrop = true;
      self.setState({wnds: wnds });
    }
    row_bong(row) {
        var self = this;
        var prm = {};
        prm.req = "pos.pos_bq.bongrow";
        prm.row = row;
        prm.status = "09";

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret.rca));

            //self.setState({bqa: ret.rca });
            //toastr.success("OK", "SAPI");
            var msg = { ok: true, text: "BONGAD ..." };
            self.setState({msg: msg });
            setTimeout(function(){
                self.setState({msg: {} });
            }, 1000);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    syncTb(tb){
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }

  render() {

    var title = this.props.title;
    if(!title) title = "Titel";

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="m2_backdrop" /> : null }
        <div className="m2_dlg mx_80w flex-col" style={ this.dlg_style() }>
        <div className="flex-row " style={{padding:"0px",height:"50px",lineHeight:"50px", background: "#1a456b", color: "#fff"}}>
                <div className="flex-row flex" style={{padding:"0px 5px", fontSize: "22px"}}>
                    <div>BONGKÖ { this.state.rumsnr }</div>
                </div>
            <div className="wnd-close-btn" onClick={() => this.bq_close() }>X</div>
        </div>
        <div className="mx_content flex">

        <div className="divider_orange"></div>

            <div id="bqnTable">
            <table className="table table-bordered table-hover tb fixed_header">
                <thead>
                <tr>
                    <th>Bongnr</th>
                    <th>State</th>
                    <th>Status</th>
                    <th>Bord</th>
                    <th>Notanr</th>
                    <th>Term</th>
                    <th>Rader</th>
                    <th>Tid</th>
                </tr>
                </thead>
                <tbody style={ this.tb_style() }>
                { this.state.bqa.map((row, key) =>
                <tr key={key}  onDoubleClick={() => this.show_bong(row) }>
                    <td>{ row.bongnr }</td>
                    <td>{ row.state }</td>
                    <td>{ row.status }</td>
                    <td>{ row.bordnr }</td>
                    <td>{ row.notanr }</td>
                    <td>{ row.terminal }</td>
                    <td>{ row.rader }</td>
                    <td>{ row.tid }</td>
                </tr>
                )}
                </tbody>
            </table>
            </div>

        </div>

        <div className="mx_foot flex-row">
            <button className="btn btn-hw-red w250" onClick={() => this.bq_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <button className="btn btn-hw-green w250" onClick={() => this.bqn() } >
                UPPDATERA
            </button>
        </div>
      </div>
        { this.state.wnds.bong ? <Bq_Bong wnds={this.state.wnds} ctx={this} /> : null}
        <Wnd_Ok msg={this.state.msg} ctx={this} />
    </div>
	;
	return html;
  };
}

export default Bq_List;